/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import { Box, Container, Grid, Typography, useMediaQuery } from '@mui/material';
import { MailOutlined, Visibility, VisibilityOff } from '@mui/icons-material';
import KeyIcon from '@mui/icons-material/Key';
import { redirectTo } from 'AppRoutes';
import React, { useEffect, useState } from 'react';
import { isUserAuthenticated } from 'utils/auth.utils';
import LoginForm from 'component/Login/LoginForm';
import LoginFooter from 'component/Login/LoginFooter';
import { loginFootMessageDiv } from 'component/Login/Login.style';
import {
  imageContainer,
  loginBkgrd,
  loginContainer,
  loginInfo,
  loginLogoContainer,
  messageText,
} from './LoginPage.style';
import { poppins300 } from 'theme/common.style';
import packageJson from '../../../../package.json';
import { useTheme } from '@emotion/react';
import { Basename_url } from 'constant/app.config';

export const cacheClear = () => {
  let version = localStorage.getItem('version');
  if (version != packageJson.version) {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name);
        });
      });

      // Makes sure the page reloads. Changes are only visible after you refresh.
      window.location.reload(true);
    }

    localStorage.setItem('version', packageJson.version);
  }
};
function LoginPage() {
  const theme = useTheme();
  const appVersion = packageJson.version;
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  React.useEffect(() => {
    cacheClear();
  }, []);

  if (isUserAuthenticated()) {
    window.open(`${Basename_url}` + '/dashboard', '_self');
  }

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const shouldMoveUp = windowHeight < 600;
  return (
    <Grid container sx={{ height: '100%', width: '100%' }}>
      {!matchesmd && (
        <Grid
          item
          xl={4}
          lg={4.5}
          md={5}
          height={'100%'}
          sx={[
            loginLogoContainer,
            { paddingRight: matcheslg ? '2rem' : matches ? '3rem' : '5rem' },
          ]}
        >
          <div
            style={{ width: '100%', display: 'flex', justifyContent: 'right' }}
          >
            <Box sx={imageContainer} height={'30vh'} width={'30vh'}>
              <img
                alt="Logo"
                width={'100%'}
                height={'100%'}
                src={require('assets/images/retrex_logo.png')}
              />
            </Box>
          </div>
          <Box
            sx={{
              paddingRight: '30px',
              paddingTop: '37px',
              paddingLeft: matches ? '3rem' : matcheslg ? '1rem' : '5rem',
            }}
          >
            <Typography
              component="p"
              sx={messageText}
              whiteSpace={'wrap'}
              fontSize={window.innerHeight < 750 ? '30px' : '48px'}
            >
              Powerful, easy-to-use application for real estate trading
            </Typography>
          </Box>
          <Typography
            component="p"
            sx={
              (messageText,
              {
                position: 'fixed',
                bottom: '86px',
                left: '86px',
                ...poppins300,
                color: '#FFFFFF',
                fontStyle: 'normal',
                lineHeight: '18px',
              })
            }
          >
            v{appVersion}
          </Typography>
        </Grid>
      )}

      <Grid
        item
        container
        xl={8}
        lg={7.5}
        md={7}
        sm={12}
        xs={12}
        sx={loginBkgrd}
        display={'flex'}
        direction={'column'}
        paddingBottom={shouldMoveUp && '-20px'}
      >
        <LoginForm
          btnText="SIGN UP"
          labelText="Don’t have an account?"
          type="signup"
        />
        {/* {matchessm ? (
                 <Grid item  height={"100vh"}>

                      <LoginForm  btnText="SIGN UP"
                      labelText="Don’t have an account?"
                      type="signup" />
                      </Grid>
                    ) : (
                   <>
                 <Grid item  height={"60vh"}>

                  <LoginForm  btnText="SIGN UP"
                labelText="Don’t have an account?"
                type="signup" />

                  </Grid>
                  <Grid item  height={"40vh"}>
                  <LoginFooter/>
                  </Grid> 
                  </>
                   )} */}
      </Grid>
      {/* <Grid xs={3} sx={{ ...loginInfo, ...loginBkgrd }}>
              <LoginFooter
                btnText="SIGN UP"
                labelText="Don’t have an account?"
                type="signup"
              />
            </Grid> */}
    </Grid>
  );
}

export default LoginPage;
